/*
  main.js
*/

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify'
import VueI18n from 'vue-i18n'
import { APP_LOG_LEVEL, checkUserAgent } from '@/common'
import router from '@/router'
import store from '@/store'
import App from '@/App'
import Login from '@/components/Login'
import VueLogger from 'vuejs-logger'
import('../node_modules/vuetify/dist/vuetify.min.css')
//import('../node_modules/material-design-icons-iconfont/dist/material-design-icons.css')
import('@/common/hm-common.css')
// 多言語データ読み込み
const strings_data = require('@/common/strings.json')

const user_agent = checkUserAgent()
if (user_agent.match(/IE/) !== null) {
  if (user_agent.match(/IE11/) !== null) {
    alert('お使いのブラウザは、現VersionのHere\'s Meでは最適なパフォーマンスで動作せず、非推奨となります.' +
          'Edge, Chrome, Firefox等のブラウザでのご利用を推奨しています.')
  }
  else {
    try {
      throw new Error('ie elder version')
    }
    catch (e) {
      alert('Here\'Meでは、お使いのブラウザはサポートしておりません.' +
            'Edge, Chrome, Firefox等のブラウザをお使いください.')
    }
  }
}

// Vue起動時のProductionヒントを非表示
Vue.config.productionTip = false

// 多言語設定
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'ja',  /* @Todo systemからdefault言語を取得する */
  messages: strings_data,
})

// Logger
Vue.use(VueLogger, {
  logLevel: APP_LOG_LEVEL,
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true,
})

// Vuetify 表示用ライブラリ
// breakpoints app-breakpoint.js
//   xs : < 600
//   sm : < 960
//   md : < 1280 - 16
//   lg : < 1920 - 16
//   xl : >= 1920 -16
Vue.use(Vuetify, {
  // @Memo テーマ配色はここで定義する。現在はprimaryのみ定義
  theme: {
    primary: '#8b0000',
  },
  icons: {
    iconfont: 'md',
  },
})

Vue.config.performance = true

let windowStatePlugin = {
  install: function (Vue) {
    let state = {
      isFocus: false,
      isResume: false,
    }
    const onFocus = function () {
      state.isFocus = true
    }
    const onBlur = function () {
      state.isFocus = false
    }
    const onResume = function () {
      state.isResume = true
    }
    const onPause = function () {
      state.isResume = false
    }
    window.addEventListener('focus', onFocus, false)
    window.addEventListener('blur', onBlur, false)

    // アプリ用(Androidでfocus/blurが拾えないため)
    document.addEventListener('resume', onResume, false)
    document.addEventListener('pause', onPause, false)

    Vue.util.defineReactive(Vue.prototype, '$window', state)
  }
}
Vue.use(windowStatePlugin)

// @Memo IE11では:の省略形でエラーになる
// Vueインスタンス生成
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n: i18n,
  router: router,
  store: store,
  template: '<App/>',
  components: {
    'App': App,
    'Login': Login
  },
})



// WEBPACK FOOTER //
// ./src/main.js